import { render, staticRenderFns } from "./WorkspaceMovePanel.vue?vue&type=template&id=7317f9c2&scoped=true"
import script from "./WorkspaceMovePanel.vue?vue&type=script&lang=ts"
export * from "./WorkspaceMovePanel.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceMovePanel.vue?vue&type=style&index=0&id=7317f9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317f9c2",
  null
  
)

export default component.exports